import common from '@/sui/data/sheets/convert/common'

const catheters = [
  { field: 'central' },
  { field: 'type' },
  { field: 'insertion', special: 'date' },
  { field: 'removed' },
  { field: 'removal', special: 'date' }
]

export default {
  '2019': [
    { field: 'sheetNumber', special: 'numeric' },
    { field: 'uf' },
    { field: 'unitType', special: 'unitType' },
    { field: 'birthdate', special: 'date' },
    { field: 'sex' },
    { field: 'entry', special: 'date' },
    { field: 'origin', cfield: 'patientOrigin' },
    { field: 'trauma' },
    { field: 'diagnosis' },
    { field: 'immuno' },
    { field: 'antibio' },
    { field: 'mixManagment' },
    { field: 'mainSeverity', special: 'mainSeverity' },
    { field: 'otherSeverity', special: 'otherSeverity' },
    { field: 'birthWeight', special: 'numeric' },
    { field: 'gestationalAge', special: 'numeric' },
    { field: 'catheters', array: catheters },
    { field: 'bacteremias', array: common.bacteremia.v1 },
    { field: 'dead' },
    { field: 'death', special: 'date' },
    { field: 'exit', special: 'date' }
  ]
}
